





































































































import { Component, Prop, Watch, Inject, Vue } from "vue-property-decorator";
import { required } from "vuelidate/lib/validators";
import { IHotelInfo } from "@/@types/hotel-info/info";
import { validationMixin } from "vuelidate";
import { ILocale } from "@/@types/locale";
import { VueEditor } from "vue2-editor";

import SubmitResetButtonGroop from "@/components/buttons/submit-reset-button-groop.vue";
import LanguagesButtons from "@/components/buttons/languages-buttons.vue";
import UploadPicture from "@/components/app/images/upload-picture.vue";
import ButtonBack from "@/components/buttons/button-back.vue";
import BSwitch from "@/components/app/switchs/b-switch.vue";

import HotelInfoDemo from "@/components/demo/hotel-info/hotel-info-demo.vue";
import MainDemo from "@/components/demo/main-demo.vue";

@Component({
  components: {
    SubmitResetButtonGroop,
    LanguagesButtons,
    ButtonBack,
    VueEditor,
    BSwitch,
    HotelInfoDemo,
    MainDemo,
    UploadPicture,
  },
  mixins: [validationMixin],
  validations: {
    name: { required },
  },
})
export default class HotelInfoAdd extends Vue {
  @Inject("backgroundFolder") readonly backgroundFolder!: string;
  @Inject("imageFolder") readonly imageFolder!: string;

  @Prop({ type: Array, default: () => [] }) infoList!: Array<IHotelInfo>;
  @Prop({ type: String, default: "" }) id!: string;

  locale = this.$store.getters.getLanguages[0];

  name = "";
  description = "";
  show = true;
  background = "";
  image = "";
  sort_order: number | undefined;

  names: ILocale = {};
  descriptions: ILocale = {};

  @Watch("name")
  updateNames(): void {
    this.names[this.locale] = this.name;
  }

  @Watch("description")
  updateDescription(): void {
    this.descriptions[this.locale] = this.description;
  }

  @Watch("locale")
  getParams(): void {
    if (this.names)
      this.name = this.names[this.locale] ? this.names[this.locale] : "";
    else this.name = "";

    if (this.descriptions)
      this.description = this.descriptions[this.locale]
        ? this.descriptions[this.locale]
        : "";
    else this.description = "";
  }

  onSubmit(event: HTMLFormElement): void {
    event.preventDefault();
    if (this.$v.$invalid) {
      console.log("invalid");
      this.$v.$touch();
      return;
    }

    const information: IHotelInfo = {
      _id: this.id ? this.id : undefined,
      name: this.names,
      description: this.descriptions,
      show: this.show,
      src: {
        background: this.background,
        image: this.image,
      },
      sort_order: this.sort_order,
      update_history: undefined,
    };

    if (!this.id) {
      this.$emit("updateInfo", information, null);
      this.$router.push({ name: "HotelInfoList" });
      this.$emit("clear");
      return;
    }

    const info = this.infoList.find((el) => el._id == this.id);
    if (!info) {
      this.$notify({
        group: "global",
        text: String(this.$i18n.t("alerts.emptyUpdate")),
        type: "warn",
      });
      return;
    }

    let data: Partial<IHotelInfo> = {};
    for (let key of Object.keys(information)) {
      if (
        JSON.stringify(info[key as keyof IHotelInfo]) !==
        JSON.stringify(information[key as keyof IHotelInfo])
      )
        data[key as keyof IHotelInfo] = information[key as keyof IHotelInfo];
    }
    this.$emit("updateInfo", data, this.id);
    this.$router.push({ name: "HotelInfoList" });
    this.$emit("clear");
  }

  onReset(): void {
    this.name = "";
    this.description = "";
    this.names = {};
    this.descriptions = {};
    this.background = "";
    this.image = "";
    this.show = false;
  }

  startChange(info: IHotelInfo | undefined): void {
    if (!info) return;
    this.names = Object.assign({}, info.name);
    this.descriptions = Object.assign({}, info.description);
    this.background = info.src ? info.src.background : "";
    this.image = info.src ? info.src.image : "";
    this.getParams();
  }

  mounted(): void {
    if (this.id)
      this.startChange(this.infoList.find((el) => el._id == this.id));
  }
}
